// 카카오맵 어댑터 — MapPicker 공통 인터페이스 { load, createPicker }
// InfoWindow 기본 말풍선 대신 CustomOverlay 로 "위치 선택" 버튼만 띄워 구글과 시각 일관성 유지.

import { loadKakaoSdk } from '../../../utils/kakaoLoader';

export const load = () => loadKakaoSdk();

// container 에 지도/마커/오버레이 생성. handlers: { onSelect(lat,lon), onMove(lat,lon) }
// 반환 handle: { recenter(lat,lon), destroy() }
export const createPicker = (container, initPos, handlers) => {
    let k = window.kakao.maps;
    let center = new k.LatLng(initPos.lat, initPos.lon);

    let map = new k.Map(container, { center: center, level: 8 });

    let marker = new k.Marker({ position: center, draggable: true });
    marker.setMap(map);

    let btn = document.createElement("button");
    btn.type = "button";
    btn.className = "mapPickerSelectBtn";
    btn.append("위치 선택");
    btn.onclick = () => {
        let p = marker.getPosition();
        if (handlers.onSelect) handlers.onSelect(p.getLat(), p.getLng());
    };

    let overlay = new k.CustomOverlay({
        position: center,
        content: btn,
        yAnchor: 2.3,
        zIndex: 3
    });
    overlay.setMap(map);

    const moveTo = (latlng) => {
        marker.setPosition(latlng);
        overlay.setPosition(latlng);
    };

    k.event.addListener(map, 'click', (mouseEvent) => {
        let latlng = mouseEvent.latLng;
        moveTo(latlng);
        if (handlers.onMove) handlers.onMove(latlng.getLat(), latlng.getLng());
    });

    k.event.addListener(marker, 'dragend', () => {
        let p = marker.getPosition();
        overlay.setPosition(p);
        if (handlers.onMove) handlers.onMove(p.getLat(), p.getLng());
    });

    // 숨김 상태에서 열릴 수 있으므로 레이아웃 재계산
    setTimeout(() => {
        map.relayout();
        map.setCenter(marker.getPosition());
    }, 1);

    return {
        recenter: (lat, lon) => {
            let p = new k.LatLng(lat, lon);
            map.setLevel(6);
            map.setCenter(p);
            moveTo(p);
        },
        destroy: () => {
            overlay.setMap(null);
            marker.setMap(null);
        }
    };
};
